import { __assign } from "tslib";
import { createHttpTestKit } from '../http/test-kit';
import { createTicketsApi, PRESENCE_TTL, } from './';
import { createFakeGetResponder, createFakePutResponder, createFakePostResponder, createFakeDeleteResponder } from '../test-utils';
import { createMultiLingualCustomFieldsApiTestKitHandler } from '../custom-fields';
export var createTicketsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createTicketsApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetTicket: function (id) {
            return createFakeGetResponder(fakeHttp, '/tickets/' + id);
        },
        whenGetExtendedTicket: function (id) {
            return createFakeGetResponder(fakeHttp, '/tickets/' + id + '/admin');
        },
        whenAddTicketCallNote: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/".concat(dto.ticketId, "/calls/").concat(dto.callId, "/notes"))({});
        },
        whenUpdateTicketCallNote: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/".concat(dto.ticketId, "/calls/").concat(dto.callId, "/notes/").concat(dto.noteId))({});
        },
        whenDeleteTicketCallNote: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "/tickets/".concat(dto.ticketId, "/calls/").concat(dto.callId, "/notes/").concat(dto.noteId));
        },
        whenRequestCallback: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/callbackRequests')(dto);
        },
        whenCancelCallback: function (dto) {
            var reqUrl = "/tickets/".concat(dto.ticketId, "/calls/").concat(dto.callId, "/cancelCallback");
            return createFakePostResponder(fakeHttp, reqUrl)(dto);
        },
        whenRequestCallbackOnBehalf: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/callbackRequests/onBehalf')(dto);
        },
        whenTransferCallToNumber: function (dto) {
            var reqUrl = "/tickets/".concat(dto.ticketId, "/calls/").concat(dto.callId, "/transferToNumber");
            return createFakePostResponder(fakeHttp, reqUrl)(dto);
        },
        whenGetTransferHistory: function (dto) {
            var reqUrl = "/tickets/".concat(dto.ticketId, "/calls/").concat(dto.callId, "/cancelCallback");
            return createFakePostResponder(fakeHttp, reqUrl)(dto);
        },
        whenGetTicketByNumber: function (dto) {
            return createFakeGetResponder(fakeHttp, "/tickets/byNumber/".concat(dto.ticketNumber, "/admin"));
        },
        whenSyncCall: function (dto) {
            var reqUrl = "/tickets/".concat(dto.ticketId, "/calls/").concat(dto.callId, "/sync");
            return createFakePostResponder(fakeHttp, reqUrl)(dto);
        },
        whenTransferTicket: function (dto, fail) {
            // tslint:disable-next-line:max-line-length
            return createFakePostResponder(fakeHttp, "/tickets/".concat(dto.ticketId, "/transfer"), fail)({ targetUserId: dto.targetUserId });
        },
        whenSearchAdmin: function (dto) {
            // tslint:disable-next-line:max-line-length
            return createFakePostResponder(fakeHttp, '/tickets/search/admin')(dto);
        },
        whenSearchAdminIncludeConversation: function (dto) {
            // tslint:disable-next-line:max-line-length
            return createFakePostResponder(fakeHttp, '/tickets/search/admin/includeConversation')(dto);
        },
        whenReplyTickets: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/agentReplies')(dto);
        },
        whenReplyTicketsNew: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/agentReplies/new')(dto);
        },
        whenReplyTicket: function (dto) {
            var ticketId = dto.id || '';
            return createFakePostResponder(fakeHttp, "/tickets/".concat(ticketId, "/agentReply"))(dto);
        },
        whenReplyTicketHelpCenter: function (dto) {
            var ticketId = dto.id || '';
            return createFakePostResponder(fakeHttp, "/tickets/".concat(ticketId, "/replies"))(dto);
        },
        whenRelationsTickets: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/agentReplies')(dto);
        },
        whenSetTicketsStatus: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/setStatus')(dto);
        },
        whenSetTicketStatus: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/".concat(dto.id, "/status"))(dto);
        },
        whenAssignTickets: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/assign')(dto);
        },
        whenSetTicketsPriority: function (dto, fail) {
            return createFakePostResponder(fakeHttp, '/tickets/setPriority', fail)(dto);
        },
        whenMarkTicketsAsSpam: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/markSpam')(dto);
        },
        whenMarkTicketsAsHam: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/markHam')(dto);
        },
        whenDeleteTickets: function (dto) {
            return createFakePostResponder(fakeHttp, '/tickets/delete')(dto);
        },
        whenUpdateTicketsLabels: function (dto) {
            return createFakePutResponder(fakeHttp, '/tickets/labels')(dto);
        },
        whenGetSavedFilter: function (dto) {
            var id = dto.id;
            return createFakeGetResponder(fakeHttp, "/savedFilters/".concat(id));
        },
        whenGetSavedFilters: function (dto) {
            var locale = dto.locale, context = dto.context;
            var maybeContext = context ? "&context=".concat(context) : '';
            return createFakeGetResponder(fakeHttp, "/savedFilters?locale=".concat(locale).concat(maybeContext));
        },
        whenGetSavedFiltersNew: function (dto) {
            return createFakePostResponder(fakeHttp, '/savedFilters/new')(dto);
        },
        whenGetSavedFiltersPerLocale: function (dto) {
            var locales = dto.locales, context = dto.context;
            return createFakeGetResponder(fakeHttp, "/savedFilters/perLocale?locales=".concat(locales, "&context=").concat(context));
        },
        whenUpdateSavedFilter: function (dto) {
            var id = dto.id;
            return createFakePutResponder(fakeHttp, "/savedFilters/".concat(id))(dto);
        },
        whenUpdateSavedFilterNew: function (dto) {
            var id = dto.id;
            return createFakePutResponder(fakeHttp, "/savedFilters/".concat(id, "/new"))(dto);
        },
        whenDeleteSavedFilter: function (dto) {
            var id = dto.id;
            return createFakeDeleteResponder(fakeHttp, "/savedFilters/".concat(id));
        },
        whenAddSavedFilter: function (dto) {
            return createFakePostResponder(fakeHttp, "/savedFilters")(dto);
        },
        whenRenameSavedFilter: function (dto) {
            var id = dto.id;
            return createFakePutResponder(fakeHttp, "/savedFilters/".concat(id, "/rename"))(dto);
        },
        whenGetPresenceInfoList: function (dto) {
            var dtoWithTtl = dto !== '*' ? __assign(__assign({}, dto), { maxAge: PRESENCE_TTL }) : dto;
            return createFakePostResponder(fakeHttp, "/tickets/presence")(dtoWithTtl);
        },
        whenAddTicket: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/outbound")(dto);
        },
        whenAddTicketOnBehalf: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/onBehalf")(dto);
        },
        whenGetCustomFields: function () {
            return createFakeGetResponder(fakeHttp, "/fields");
        },
        whenGetFiltersTicketsCount: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/filtersCounts")(dto);
        },
        whenGetFiltersTicketsCountNew: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/filtersCounts/new")(dto);
        },
        whenGetTicketTimeline: function (dto) {
            return createFakeGetResponder(fakeHttp, "/tickets/".concat(dto.ticketId, "/timeline"));
        },
        whenGetUserTicketTimeline: function (dto) {
            return createFakeGetResponder(fakeHttp, "/tickets/".concat(dto.ticketId, "/userTimeline"));
        },
        whenAddTimelineEvent: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/".concat(dto.ticketId, "/timeline"))({ customText: dto.customText });
        },
        whenUpdateTicketCustomFields: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/".concat(dto.id, "/fields"))(__assign(__assign({}, dto), { id: undefined }));
        },
        whenApplyMacro: function (dto, fail) {
            var macroId = dto.macroId, ticketId = dto.ticketId;
            return createFakePostResponder(fakeHttp, "/tickets/".concat(ticketId, "/macros/").concat(macroId, "/execute"), fail)({ macroId: macroId });
        },
        whenGetSavedReplies: function (dto) {
            return createFakePostResponder(fakeHttp, "/savedReplies/search")(dto);
        },
        whenGetSavedReply: function (dto) {
            return createFakeGetResponder(fakeHttp, "/savedReplies/".concat(dto.id, "/admin/?locale=").concat(dto.locale));
        },
        whenCustomFields: createMultiLingualCustomFieldsApiTestKitHandler('/tickets', fakeHttp),
        whenDeleteCallRecording: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "/tickets/".concat(dto.ticketId, "/calls/").concat(dto.callId, "/deleteRecording"));
        },
        whenUpdateReplyContent: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/".concat(dto.id, "/replies/").concat(dto.replyId))(dto);
        },
        whenSetLocale: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/".concat(dto.ticketId, "/locale"))({ newLocale: dto.newLocale });
        },
        whenFollow: function (id) { return createFakePostResponder(fakeHttp, "/tickets/".concat(id, "/follow"))({}); },
        whenUnfollow: function (id) { return createFakeDeleteResponder(fakeHttp, "/tickets/".concat(id, "/follow")); },
        whenUpdateTicketContent: function (dto) {
            var id = dto.id, content = dto.content, subject = dto.subject;
            return createFakePutResponder(fakeHttp, "/tickets/".concat(id))({ content: content, subject: subject });
        },
        whenIsTicketFollowed: function (dto) { return createFakeGetResponder(fakeHttp, "/tickets/".concat(dto.id, "/follow")); },
        whenRelatedArticles: function (ticketId) { return createFakeGetResponder(fakeHttp, "/tickets/".concat(ticketId, "/relations/admin")); },
        whenRemoveRelations: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/".concat(dto.id, "/relations/remove"))({ relatedArticleIds: dto.relatedArticleIds });
        },
        whenSession: {
            whenStartForAgent: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/".concat(dto.id, "/startHandling"))(dto); },
            whenEndForAgent: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/".concat(dto.id, "/endHandling/new"))(dto); },
            whenEndForAll: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/".concat(dto.id, "/endAllHandling/new"))(dto); },
            whenBulkEndForAgent: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/endHandling/bulk")(dto); },
            whenBulkEndForAll: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/endAllHandling/bulk")(dto); },
        },
        whenReportTicketPresenceStatus: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/".concat(dto.id, "/presence"))(dto); },
        whenUpdateTicketCompany: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/company")({ ids: [dto.id], companyId: dto.companyId });
        },
        whenUpdateTicketAndAgentCompany: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/".concat(dto.id, "/setCompanyOnTicketAndUser"))({ companyId: dto.companyId });
        },
        whenSnoozeTicket: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/snooze")(dto); },
        whenUnsnoozeTicket: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/unSnooze")(dto); },
        whenMergeTickets: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/merge")(dto);
        },
        whenAddAgentInternalNote: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/".concat(dto.id || '', "/agentInternalNote"))(dto); },
        whenAddAgentInternalNotes: function (dto) { return createFakePostResponder(fakeHttp, '/tickets/agentInternalNotes')(dto); },
        whenGetReplyRawEmail: function (dto) { return createFakeGetResponder(fakeHttp, "/tickets/".concat(dto.ticketId, "/replies/").concat(dto.replyId, "/rawEmail")); },
        whenUpdateTicketBrand: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/".concat(dto.ticketId, "/brand"))({ brandId: dto.brandId });
        },
        whenGetTicketAutoRoutingAssignments: function (id) {
            return createFakeGetResponder(fakeHttp, "/tickets/".concat(id, "/autoRouting/assignments"));
        },
        whenTransferChat: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/".concat(dto.ticketId, "/chatTransfer"))(dto);
        },
        whenTransferChatNew: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/".concat(dto.ticketId, "/chatTransfer/new"))(dto);
        },
        whenUpdateCCRecipients: function (dto) {
            return createFakePutResponder(fakeHttp, "/tickets/".concat(dto.id, "/ccRecipients"))(dto);
        },
        whenGetTicketsOfUser: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/my")(dto);
        },
        whenEscalateTicket: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/".concat(dto.id, "/escalate"))(dto); },
        whenGetTicketEscalations: function (dto) { return createFakeGetResponder(fakeHttp, "/tickets/".concat(dto.id, "/escalations")); },
        whenGetExternalProvidersEscalations: function () { return createFakeGetResponder(fakeHttp, "/tickets/externalProvidersEscalations"); },
        whenCreateTicketHelpcenter: function (dto) { return createFakePostResponder(fakeHttp, "/tickets")(dto); },
        whenUpdateSkills: function (dto) { return createFakePutResponder(fakeHttp, "/tickets/".concat(dto.id, "/skills"))(dto); },
        whenUpdateTicketsSkills: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/skills")(dto); },
        whenGetRoutingTargetGroup: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/routingTargetGroup")(dto); },
        whenCheckAvailability: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/checkAvailability")(dto); },
        whenGetTicketInteractions: function (dto) { return createFakePostResponder(fakeHttp, "/tickets/interactions")(dto); },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map